import { CSSProperties } from 'react'
import Colors from 'modules/Colors'

interface Video2IconProps {
    className?: string
    style?: CSSProperties
    color?: string
    size?: number
    onClick?: () => void
}

const Video2Icon = ({
    className,
    style,
    color = Colors.purple,
    size = 24,
    onClick,
}: Video2IconProps) => {
    return (
        <svg
            className={className}
            style={style}
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            onClick={onClick}
        >
            <rect
                x="3"
                y="5"
                width="18"
                height="14"
                rx="2"
                stroke={color}
                strokeWidth={2}
            />
            <path
                d="M14.0364 11.3876C14.5758 11.6707 14.5758 12.4428 14.0364 12.7259L10.6069 14.5259C10.1037 14.79 9.5 14.4251 9.5 13.8568L9.5 10.2567C9.5 9.68843 10.1037 9.32349 10.6069 9.58759L14.0364 11.3876Z"
                fill={color}
            />
            <path
                d="M7 5.5V19"
                stroke={color}
                strokeWidth={2}
            />
            <path
                d="M17 5.5V19"
                stroke={color}
                strokeWidth={2}
            />
            <path
                d="M17 10H21"
                stroke={color}
                strokeWidth={2}
            />
            <path
                d="M3 10H7"
                stroke={color}
                strokeWidth={2}
            />
            <path
                d="M17 14.5H21"
                stroke={color}
                strokeWidth={2}
            />
            <path
                d="M3 14.5H7"
                stroke={color}
                strokeWidth={2}
            />
        </svg>
    )
}

export default Video2Icon
